export default {
	title: '风险 / 突破口',
	risks: '风险',
	opportunities: '突破口',
	url: 'risks',
	subtitle: '',
	all_categories: '类别筛选',
	all_impacts: '影响筛选',
	all_likelihoods: '可能性筛选',
	all_stakeholders: '利益相关方筛选',
	all_stakes: '利害关系筛选',
	no_stakeholder: '无利益相关方',
	tabs: {
		filters: {
			title: '视图筛选',

			displayed_columns: '显示列',
			visualization_options: '可视化选项'
		},
		options: {
			title: '显示',
			are_links_visible: '显示全部关联',
			show_description: '显示描述',
			chart_visible_stakes: '显示利害关系',
			chart_visible_stakeholders: '显示利益相关方',
			chart_visible_risks: '显示风险',
			chart_visible_opportunities: '显示突破口'
		},
		general: {
			title: '常规'
		},
		stakeholders: {
			title: '利益相关方'
		},
		export: {
			title: '导出'
		},
		comments: {
			title: '历史'
		}
	},
	visualization_tab: '可视化',
	onboarding: {
		risks: {
			title: '审查风险',
			description:
				'以下是压在您利害关系上的风险。评估它们的可能性和影响，并修正那些您认为校准不当的项目。'
		},
		opportunities: {
			title: '审查突破口',
			description:
				'与风险相反，突破口是可以强化您利害关系的动态。保留可执行的，搁置其余。'
		}
	}
};
